/**
 * LockKeyStateService
 * 
 * Tracks the state of keyboard lock keys (CapsLock, NumLock, ScrollLock).
 */
export class LockKeyStateService extends EventTarget {
  constructor() {
    super();
    this.states = {
      CapsLock: false,
      NumLock: false,
      ScrollLock: false
    };
  }

  updateFromEvent(event) {
    let changed = false;
    
    ['CapsLock', 'NumLock', 'ScrollLock'].forEach(key => {
      const newState = event.getModifierState(key);
      if (this.states[key] !== newState) {
        this.states[key] = newState;
        changed = true;
        this.dispatchEvent(new CustomEvent('lockchange', { 
          detail: { key, state: newState } 
        }));
      }
    });

    return changed;
  }

  getState(key) {
    return this.states[key];
  }
}

export const lockKeyStateService = new LockKeyStateService();
